import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-field-price',
  components: {},
})
export default class DisplayFieldPrice extends mixins(AbstractDisplayField) {
  isPrice() {
    return this.fieldConfig.displayType === 'price';
  }

  get formattedPrice() {
    return this.$bpcHelper.formatPrice(this.value, this.emptyIfNull, this.zeroIfNull);
  }

  get valueLabel(): string {
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === this.value);
    return item?.label || item?.text || this.value;
  }
}
